module.exports = __webpack_public_path__ + "img/quotation_light.301b2553.svg";